/* eslint-disable @typescript-eslint/ban-types */
import { v4 as uuid } from "uuid";
export class Shard {
    constructor(initialValue, customId) {
        this.uuid = uuid();
        this.getId = () => {
            return this.uuid;
        };
        this.getInitialValue = () => {
            return this.value;
        };
        this.addScope = (id) => {
            this.scoped = id;
        };
        this.getScope = () => this.scoped;
        this.value = initialValue;
        if (customId)
            this.uuid = customId;
    }
}
export const shard = (initial) => {
    return new Shard(initial);
};
//# sourceMappingURL=index.js.map